import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBottomSheet } from 'vuetify/lib/components/VBottomSheet';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VChip } from 'vuetify/lib/components/VChip';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "d-flex justify-end" },
        [
          _vm.canPrint
            ? _c(
                VBtn,
                {
                  attrs: { outlined: "" },
                  on: {
                    click: function ($event) {
                      return _vm.print()
                    },
                  },
                },
                [
                  _vm._v(
                    _vm._s(_vm.$vuetify.lang.t("$vuetify.printSetting.print"))
                  ),
                ]
              )
            : _vm._e(),
          _vm.canPrint
            ? _c(
                VBtn,
                {
                  staticClass: "ml-2",
                  attrs: { outlined: "" },
                  on: {
                    click: function ($event) {
                      return _vm.printLabel()
                    },
                  },
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.$vuetify.lang.t("$vuetify.printSetting.printLabel")
                    )
                  ),
                ]
              )
            : _vm._e(),
        ],
        1
      ),
      _vm.hasInventoryShortages
        ? _c(
            VAlert,
            { staticClass: "mb-4", attrs: { type: "warning", prominent: "" } },
            [
              _c("div", [
                _c("div", { staticClass: "font-weight-bold" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$vuetify.lang.t(
                        "$vuetify.worksheet.inventoryShortageAlert.title"
                      )
                    )
                  ),
                ]),
                _c("div", { staticClass: "text-body-2" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$vuetify.lang.t(
                        "$vuetify.worksheet.inventoryShortageAlert.message",
                        _vm.shortageCount
                      )
                    )
                  ),
                ]),
              ]),
            ]
          )
        : _vm._e(),
      _vm.coa && _vm.coa.length > 0
        ? _c(
            "div",
            { staticClass: "mb-4" },
            [
              _vm.missingCoaInventory && _vm.missingCoaInventory.length > 0
                ? _c(VAlert, { attrs: { type: "warning" } }, [
                    _vm._v(
                      " Inventory with missing CoA " +
                        _vm._s(_vm.missingCoaInventory.join(", ")) +
                        " "
                    ),
                  ])
                : _vm._e(),
              _vm.labResults
                ? _c(
                    VCard,
                    [
                      _c(
                        VCardTitle,
                        {
                          staticStyle: { cursor: "pointer" },
                          on: {
                            click: function ($event) {
                              _vm.expandCard = !_vm.expandCard
                            },
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$vuetify.lang.t(
                                  "$vuetify.worksheet.foundCoa",
                                  _vm.coa.length
                                )
                              ) +
                              " "
                          ),
                        ]
                      ),
                      _c(
                        VExpandTransition,
                        [
                          _vm.expandCard
                            ? _c(
                                VList,
                                [
                                  _c("download", {
                                    staticClass: "mx-2",
                                    attrs: { fileName: "CoA Estimate" },
                                    model: {
                                      value: _vm.invertedLabResults,
                                      callback: function ($$v) {
                                        _vm.invertedLabResults = $$v
                                      },
                                      expression: "invertedLabResults",
                                    },
                                  }),
                                  _c(
                                    VListItemGroup,
                                    _vm._l(_vm.labResults, function (element) {
                                      return _c(
                                        VListItem,
                                        { key: element.id },
                                        [
                                          _c(
                                            VListItemContent,
                                            [
                                              _c(VListItemTitle, [
                                                _vm._v(_vm._s(element.name)),
                                              ]),
                                              _c(VListItemSubtitle, [
                                                _vm._v(_vm._s(element.symbol)),
                                              ]),
                                            ],
                                            1
                                          ),
                                          _c(VListItemAction, [
                                            _c("div", [
                                              _vm._v(
                                                _vm._s(
                                                  element.percentage
                                                    ? element.percentage.toFixed(
                                                        6
                                                      )
                                                    : 0
                                                )
                                              ),
                                            ]),
                                          ]),
                                        ],
                                        1
                                      )
                                    }),
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm.worksheet.deductibleWeight
        ? _c("div", { staticClass: "text-caption my-2" }, [
            _vm._v(
              " " +
                _vm._s(
                  _vm.$vuetify.lang.t("$vuetify.base.deductibleWeightPerEntry")
                ) +
                ": " +
                _vm._s(_vm._f("formatNumber")(_vm.worksheet.deductibleWeight)) +
                " " +
                _vm._s(_vm.productInfo ? _vm.productInfo.measureWeight : "") +
                " "
            ),
          ])
        : _vm._e(),
      _c(VDataTable, {
        attrs: { items: _vm.groupedEntries, headers: _vm.headers },
        scopedSlots: _vm._u([
          {
            key: "item.index",
            fn: function ({ index }) {
              return [_vm._v(" " + _vm._s(index + 1) + ". ")]
            },
          },
          {
            key: "item.createTime",
            fn: function ({ item }) {
              return [
                _vm._v(
                  " " + _vm._s(_vm._f("formatDateTime")(item.createTime)) + " "
                ),
              ]
            },
          },
          {
            key: "item.unit",
            fn: function ({ item }) {
              return [
                item.unit
                  ? _c("div", [
                      _vm._v(
                        " " +
                          _vm._s(item.unit) +
                          " " +
                          _vm._s(
                            _vm.productInfo ? _vm.productInfo.measureUnit : ""
                          ) +
                          " "
                      ),
                      _c("div", { staticClass: "text-caption" }, [
                        _vm._v(
                          " " +
                            _vm._s(_vm._f("formatNumber")(item.amountPerUnit)) +
                            " " +
                            _vm._s(
                              _vm.productInfo
                                ? _vm.productInfo.measureWeight
                                : ""
                            ) +
                            "/" +
                            _vm._s(
                              _vm.productInfo ? _vm.productInfo.measureUnit : ""
                            ) +
                            " "
                        ),
                      ]),
                    ])
                  : _vm._e(),
              ]
            },
          },
          {
            key: "item.grossWeight",
            fn: function ({ item }) {
              return [
                _c(
                  "div",
                  { staticClass: "d-flex align-center" },
                  [
                    item.inventoryDecisionStatus === "NEEDS_REVIEW"
                      ? _c(
                          VTooltip,
                          {
                            attrs: { bottom: "", "max-width": "400" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function ({ on, attrs }) {
                                    return [
                                      _c(
                                        VChip,
                                        _vm._g(
                                          _vm._b(
                                            {
                                              staticClass: "mr-2",
                                              attrs: {
                                                "x-small": "",
                                                color: "warning",
                                              },
                                            },
                                            "v-chip",
                                            attrs,
                                            false
                                          ),
                                          on
                                        ),
                                        [
                                          _c(
                                            VIcon,
                                            {
                                              attrs: {
                                                "x-small": "",
                                                left: "",
                                              },
                                            },
                                            [_vm._v("mdi-alert")]
                                          ),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$vuetify.lang.t(
                                                  "$vuetify.worksheet.status.needsReview"
                                                )
                                              ) +
                                              " "
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          },
                          [
                            _c("span", [
                              _c("strong", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$vuetify.lang.t(
                                      "$vuetify.worksheet.inventoryShortfall"
                                    )
                                  )
                                ),
                              ]),
                              _c("br"),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.formatShortageMessage(item)) +
                                  " "
                              ),
                            ]),
                          ]
                        )
                      : item.inventoryDecisionStatus === "BACKORDER"
                      ? _c(
                          VChip,
                          {
                            staticClass: "mr-2",
                            attrs: {
                              "x-small": "",
                              color: "info",
                              title: "Backorder - waiting for inventory",
                            },
                          },
                          [
                            _c(
                              VIcon,
                              { attrs: { "x-small": "", left: "" } },
                              [_vm._v("mdi-clock-outline")]
                            ),
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$vuetify.lang.t(
                                    "$vuetify.worksheet.status.backorder"
                                  )
                                ) +
                                " "
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                ),
                _vm._v(
                  " " +
                    _vm._s(_vm._f("formatNumber")(item.grossWeight)) +
                    " " +
                    _vm._s(
                      _vm.productInfo ? _vm.productInfo.measureWeight : ""
                    ) +
                    " "
                ),
                _vm.getDeductibleWeight(item) > 0
                  ? _c("div", { staticClass: "text-caption" }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$vuetify.lang.t(
                              "$vuetify.base.deductibleWeight"
                            )
                          ) +
                          ": " +
                          _vm._s(
                            _vm._f("formatNumber")(
                              _vm.getDeductibleWeight(item)
                            )
                          ) +
                          " " +
                          _vm._s(
                            _vm.productInfo ? _vm.productInfo.measureWeight : ""
                          ) +
                          " "
                      ),
                    ])
                  : _vm._e(),
                item._isGrouped &&
                item._groupEntries &&
                item._groupEntries.length > 0
                  ? _c(
                      "div",
                      { staticClass: "text-caption" },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "font-weight-medium d-flex align-center",
                            staticStyle: {
                              cursor: "pointer",
                              "user-select": "none",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.toggleGroupExpansion(
                                  item.entryGroupId
                                )
                              },
                            },
                          },
                          [
                            _c(
                              VIcon,
                              { staticClass: "mr-1", attrs: { small: "" } },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.expandedGroups[item.entryGroupId]
                                        ? "mdi-chevron-down"
                                        : "mdi-chevron-right"
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                            _c("span", [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$vuetify.lang.t(
                                      "$vuetify.worksheet.inventoriesUsed",
                                      item._groupEntries.length
                                    )
                                  ) +
                                  " "
                              ),
                              _c(
                                "span",
                                {
                                  staticClass: "ml-1 grey--text text--darken-1",
                                },
                                [
                                  _vm._v(
                                    " (" +
                                      _vm._s(
                                        _vm._f("formatNumber")(
                                          _vm.getTotalReservedWeight(
                                            item._groupEntries
                                          )
                                        )
                                      ) +
                                      " " +
                                      _vm._s(
                                        _vm.productInfo
                                          ? _vm.productInfo.measureWeight
                                          : ""
                                      ) +
                                      " " +
                                      _vm._s(
                                        _vm.worksheet.status === "USED"
                                          ? _vm.$vuetify.lang.t(
                                              "$vuetify.worksheet.consumed"
                                            )
                                          : _vm.$vuetify.lang.t(
                                              "$vuetify.worksheet.reserved"
                                            )
                                      ) +
                                      ") "
                                  ),
                                ]
                              ),
                            ]),
                          ],
                          1
                        ),
                        _c(VExpandTransition, [
                          _vm.expandedGroups[item.entryGroupId]
                            ? _c(
                                "div",
                                { staticClass: "mt-2 ml-4" },
                                _vm._l(item._groupEntries, function (entry) {
                                  return _c(
                                    "div",
                                    {
                                      key: entry.id,
                                      class: [
                                        "mb-1",
                                        entry.inventoryDecisionStatus ===
                                        "NEEDS_REVIEW"
                                          ? "shortage-entry"
                                          : "",
                                      ],
                                    },
                                    [
                                      entry.inventoryDecisionStatus ===
                                      "NEEDS_REVIEW"
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex align-center warning--text",
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "flex-grow-1" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "font-weight-bold",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$vuetify.lang.t(
                                                              "$vuetify.worksheet.shortageEntry"
                                                            )
                                                          ) +
                                                          ": " +
                                                          _vm._s(
                                                            _vm._f(
                                                              "formatNumber"
                                                            )(entry.netWeight)
                                                          ) +
                                                          " " +
                                                          _vm._s(
                                                            _vm.productInfo
                                                              ? _vm.productInfo
                                                                  .measureWeight
                                                              : ""
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                  entry.inventoryDecisionNote
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "text-caption",
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm.formatShortageMessage(
                                                                  entry
                                                                )
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm.canResolveEntry(entry)
                                                    ? _c(
                                                        "div",
                                                        { staticClass: "mt-2" },
                                                        [
                                                          _c(
                                                            VBtn,
                                                            {
                                                              attrs: {
                                                                "x-small": "",
                                                                outlined: "",
                                                                color:
                                                                  "primary",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    $event.stopPropagation()
                                                                    return _vm.openResolutionDialog(
                                                                      entry
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                VIcon,
                                                                {
                                                                  attrs: {
                                                                    "x-small":
                                                                      "",
                                                                    left: "",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "mdi-swap-horizontal"
                                                                  ),
                                                                ]
                                                              ),
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    _vm.$vuetify.lang.t(
                                                                      "$vuetify.worksheet.inventoryResolution.reassign"
                                                                    )
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex justify-space-between",
                                            },
                                            [
                                              _vm.inventoryMap[
                                                entry.inventoryId
                                              ]
                                                ? _c("div", [
                                                    _c(
                                                      "a",
                                                      {
                                                        staticClass: "link",
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.viewInventory(
                                                              entry.inventoryId
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _vm.inventoryMap[
                                                          entry.inventoryId
                                                        ].documentNumber
                                                          ? _c("span", [
                                                              _vm._v(
                                                                "Doc #: " +
                                                                  _vm._s(
                                                                    _vm
                                                                      .inventoryMap[
                                                                      entry
                                                                        .inventoryId
                                                                    ]
                                                                      .documentNumber
                                                                  ) +
                                                                  " / "
                                                              ),
                                                            ])
                                                          : _vm._e(),
                                                        _vm._v(
                                                          " ID: " +
                                                            _vm._s(
                                                              _vm.inventoryMap[
                                                                entry
                                                                  .inventoryId
                                                              ].id
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                  ])
                                                : _vm._e(),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "grey--text text--darken-1",
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm._f("formatNumber")(
                                                          entry.netWeight
                                                        )
                                                      ) +
                                                      " " +
                                                      _vm._s(
                                                        _vm.productInfo
                                                          ? _vm.productInfo
                                                              .measureWeight
                                                          : ""
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                    ]
                                  )
                                }),
                                0
                              )
                            : _vm._e(),
                        ]),
                      ],
                      1
                    )
                  : item.inventoryId && _vm.inventoryMap[item.inventoryId]
                  ? _c("div", { staticClass: "text-caption" }, [
                      _vm.inventoryMap[item.inventoryId].productName
                        ? _c("div", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.inventoryMap[item.inventoryId].productName
                                ) +
                                " "
                            ),
                          ])
                        : _vm._e(),
                      _c(
                        "a",
                        {
                          staticClass: "link",
                          on: {
                            click: function ($event) {
                              return _vm.viewSelectedInventory(item)
                            },
                          },
                        },
                        [
                          _vm.inventoryMap[item.inventoryId].documentNumber
                            ? _c("span", [
                                _vm._v(
                                  "Doc #: " +
                                    _vm._s(
                                      _vm.inventoryMap[item.inventoryId]
                                        .documentNumber
                                    ) +
                                    " / "
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(
                            " ID: " +
                              _vm._s(_vm.inventoryMap[item.inventoryId].id) +
                              " "
                          ),
                        ]
                      ),
                    ])
                  : _vm._e(),
                !item._isGrouped && _vm.canResolveEntry(item)
                  ? _c(
                      "div",
                      { staticClass: "mt-2" },
                      [
                        _c(
                          VBtn,
                          {
                            attrs: {
                              "x-small": "",
                              outlined: "",
                              color: "primary",
                            },
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.openResolutionDialog(item)
                              },
                            },
                          },
                          [
                            _c(
                              VIcon,
                              { attrs: { "x-small": "", left: "" } },
                              [_vm._v("mdi-swap-horizontal")]
                            ),
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$vuetify.lang.t(
                                    "$vuetify.worksheet.inventoryResolution.reassign"
                                  )
                                ) +
                                " "
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            },
          },
          {
            key: "item.adjustmentWeight",
            fn: function ({ item }) {
              return [
                _vm._v(
                  " " +
                    _vm._s(item.netAdjustmentWeight > 0 ? "+" : "") +
                    _vm._s(_vm._f("formatNumber")(item.netAdjustmentWeight)) +
                    " " +
                    _vm._s(
                      _vm.productInfo ? _vm.productInfo.measureWeight : ""
                    ) +
                    " "
                ),
              ]
            },
          },
          {
            key: "item.netWeight",
            fn: function ({ item }) {
              return [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm._f("formatNumber")(
                        item.netWeight +
                          (item.netAdjustmentWeight
                            ? item.netAdjustmentWeight
                            : 0)
                      )
                    ) +
                    " " +
                    _vm._s(
                      _vm.productInfo ? _vm.productInfo.measureWeight : ""
                    ) +
                    " "
                ),
              ]
            },
          },
          {
            key: "item.files",
            fn: function ({ item }) {
              return [
                item.files && item.files.length > 0
                  ? _c(
                      "div",
                      [
                        _vm.isMobile
                          ? _c(
                              VBtn,
                              {
                                attrs: { text: "" },
                                on: {
                                  click: function ($event) {
                                    return _vm.showImages(item)
                                  },
                                },
                              },
                              [_vm._v(_vm._s(item.files.length) + " File")]
                            )
                          : _c(
                              "div",
                              { staticClass: "d-flex flex-row" },
                              _vm._l(
                                _vm.getEntryImages(item),
                                function (img, index) {
                                  return _c(VImg, {
                                    key: index,
                                    class: `${
                                      item.files.length > 1 ? "mr-2" : ""
                                    } my-2`,
                                    attrs: {
                                      contain: "",
                                      "aspect-ratio": "1.7",
                                      "max-height": "100",
                                      src: img.src,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.showImages(item)
                                      },
                                    },
                                  })
                                }
                              ),
                              1
                            ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            },
          },
          {
            key: "item.action",
            fn: function ({ item }) {
              return [
                _c(
                  VMenu,
                  {
                    attrs: { "offset-y": "" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "activator",
                          fn: function ({ on, attrs }) {
                            return [
                              _c(
                                VBtn,
                                _vm._g(
                                  _vm._b(
                                    { attrs: { icon: "" } },
                                    "v-btn",
                                    attrs,
                                    false
                                  ),
                                  on
                                ),
                                [_c(VIcon, [_vm._v("mdi-dots-vertical")])],
                                1
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      true
                    ),
                  },
                  [
                    _c(
                      VList,
                      { staticClass: "pa-2", attrs: { width: "200px" } },
                      [
                        _c(
                          VListItem,
                          {
                            on: {
                              click: function ($event) {
                                _vm.selectedEntry = item
                                _vm.adjustmentDialog = true
                              },
                            },
                          },
                          [
                            _c(
                              VListItemIcon,
                              [_c(VIcon, [_vm._v("mdi-plus")])],
                              1
                            ),
                            _c(VListItemContent, [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$vuetify.lang.t(
                                      "$vuetify.base.adjustmentWeight"
                                    )
                                  ) +
                                  " "
                              ),
                            ]),
                          ],
                          1
                        ),
                        _vm.btReprintAvailable
                          ? _c(
                              VListItem,
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.$emit("reprintEntry", item)
                                  },
                                },
                              },
                              [
                                _c(
                                  VListItemIcon,
                                  [
                                    _c(VIcon, [
                                      _vm._v("mdi-printer-wireless"),
                                    ]),
                                  ],
                                  1
                                ),
                                _c(VListItemContent, [
                                  _vm._v(
                                    " พิมพ์ป้ายใหม่ (บลูทูธ) / Reprint (Bluetooth) "
                                  ),
                                ]),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.canPrint
                          ? _c(
                              VListItem,
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.printLabel(item)
                                  },
                                },
                              },
                              [
                                _c(
                                  VListItemIcon,
                                  [
                                    _c(VIcon, [
                                      _vm._v("mdi-printer-outline"),
                                    ]),
                                  ],
                                  1
                                ),
                                _c(VListItemContent, [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$vuetify.lang.t(
                                          "$vuetify.printSetting.printLabel"
                                        )
                                      ) +
                                      " "
                                  ),
                                ]),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.worksheet.status == "PENDING" &&
                        _vm.editable &&
                        !(item._isGrouped && item.entryGroupId)
                          ? _c(
                              VListItem,
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.editEntry(item)
                                  },
                                },
                              },
                              [
                                _c(
                                  VListItemIcon,
                                  [
                                    _c(VIcon, [
                                      _vm._v("mdi-pencil-outline"),
                                    ]),
                                  ],
                                  1
                                ),
                                _c(VListItemContent, [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$vuetify.lang.t(
                                          "$vuetify.base.edit"
                                        )
                                      ) +
                                      " "
                                  ),
                                ]),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.worksheet.status == "PENDING" && _vm.editable
                          ? _c(
                              VListItem,
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.deleteItem(item)
                                  },
                                },
                              },
                              [
                                _c(
                                  VListItemIcon,
                                  [
                                    _c(VIcon, [
                                      _vm._v("mdi-delete-outline"),
                                    ]),
                                  ],
                                  1
                                ),
                                _c(VListItemContent, [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$vuetify.lang.t(
                                          "$vuetify.base.delete"
                                        )
                                      ) +
                                      " "
                                  ),
                                ]),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.worksheet.status == "PENDING" &&
                        _vm.canResolveEntry(item)
                          ? _c(
                              VListItem,
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.openResolutionDialog(item)
                                  },
                                },
                              },
                              [
                                _c(
                                  VListItemIcon,
                                  [
                                    _c(VIcon, [
                                      _vm._v("mdi-swap-horizontal"),
                                    ]),
                                  ],
                                  1
                                ),
                                _c(VListItemContent, [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$vuetify.lang.t(
                                          "$vuetify.worksheet.inventoryResolution.reassign"
                                        )
                                      ) +
                                      " "
                                  ),
                                ]),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
          },
          {
            key: "body.append",
            fn: function ({}) {
              return [
                _c("tr", [
                  _c("td", { attrs: { colspan: _vm.headers.length } }, [
                    _c("div", { staticClass: "ma-4 text-subtitle-2" }, [
                      _c(
                        "div",
                        { staticClass: "d-flex justify-content-between" },
                        [
                          _c("div", [
                            _vm._v(
                              _vm._s(_vm.$vuetify.lang.t("$vuetify.base.total"))
                            ),
                          ]),
                          _c("div", { staticClass: "ml-5" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm._f("formatNumber")(
                                    _vm.sum ? _vm.sum.netWeight : 0
                                  )
                                ) +
                                " " +
                                _vm._s(_vm.weightUnit) +
                                " "
                            ),
                          ]),
                        ]
                      ),
                      _vm.worksheet.targetWeight &&
                      _vm.worksheet.targetWeight > 0
                        ? _c(
                            "div",
                            { staticClass: "d-flex justify-content-between" },
                            [
                              _c("div", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$vuetify.lang.t("$vuetify.base.target")
                                  )
                                ),
                              ]),
                              _c("div", { staticClass: "ml-5" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm._f("formatNumber")(
                                        _vm.worksheet.targetWeight
                                      )
                                    ) +
                                    " " +
                                    _vm._s(_vm.weightUnit) +
                                    " "
                                ),
                              ]),
                            ]
                          )
                        : _vm._e(),
                      _vm.worksheet.targetWeight &&
                      _vm.worksheet.targetWeight > 0
                        ? _c(
                            "div",
                            { staticClass: "d-flex justify-content-between" },
                            [
                              _c("div", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$vuetify.lang.t("$vuetify.base.remain")
                                  )
                                ),
                              ]),
                              _c("div", { staticClass: "ml-5" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm._f("formatNumber")(
                                        _vm.remainingWeight
                                      )
                                    ) +
                                    " " +
                                    _vm._s(_vm.weightUnit) +
                                    " "
                                ),
                              ]),
                            ]
                          )
                        : _vm._e(),
                    ]),
                  ]),
                ]),
              ]
            },
          },
        ]),
      }),
      _c(
        VDialog,
        {
          staticStyle: { "z-index": "1000" },
          attrs: { fullscreen: "" },
          model: {
            value: _vm.imgDialog,
            callback: function ($$v) {
              _vm.imgDialog = $$v
            },
            expression: "imgDialog",
          },
        },
        [
          _c(
            VCard,
            [
              _c(VCardTitle, { staticClass: "justify-end" }, [
                _c(
                  "div",
                  [
                    _c(
                      VBtn,
                      {
                        attrs: { icon: "" },
                        on: {
                          click: function ($event) {
                            _vm.imgDialog = null
                          },
                        },
                      },
                      [_c(VIcon, [_vm._v("mdi-close")])],
                      1
                    ),
                  ],
                  1
                ),
              ]),
              _c(
                VCardText,
                [
                  _vm.images && _vm.images.length > 0
                    ? _c(
                        VCarousel,
                        {
                          attrs: {
                            continuous: "",
                            "hide-delimiter-background": "",
                            height: "80vh",
                          },
                          model: {
                            value: _vm.imgIndex,
                            callback: function ($$v) {
                              _vm.imgIndex = $$v
                            },
                            expression: "imgIndex",
                          },
                        },
                        _vm._l(_vm.images, function (img, i) {
                          return _c(
                            VCarouselItem,
                            {
                              key: i,
                              attrs: {
                                "reverse-transition": "fade-transition",
                                transition: "fade-transition",
                              },
                            },
                            [
                              _c(
                                VContainer,
                                {
                                  staticClass:
                                    "fill-height align-items-center justify-content-center",
                                },
                                [
                                  _c(
                                    VLayout,
                                    {
                                      staticClass: "flex-column",
                                      attrs: { "justify-center": "" },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex justify-space-between",
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "text-subtitle-2 mb-2",
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$vuetify.lang.t(
                                                      "$vuetify.base.entry"
                                                    )
                                                  ) +
                                                  " " +
                                                  _vm._s(img.entryIndex) +
                                                  "/" +
                                                  _vm._s(_vm.images.length) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                          _c("div", [
                                            img.grossWeight
                                              ? _c("div", [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$vuetify.lang.t(
                                                          "$vuetify.base.grossWeight"
                                                        )
                                                      ) +
                                                      ": " +
                                                      _vm._s(
                                                        _vm._f("formatNumber")(
                                                          img.grossWeight
                                                        )
                                                      ) +
                                                      " " +
                                                      _vm._s(
                                                        _vm.productInfo
                                                          ? _vm.productInfo
                                                              .measureWeight
                                                          : ""
                                                      ) +
                                                      " "
                                                  ),
                                                ])
                                              : _vm._e(),
                                            _vm.getDeductibleWeight(img) > 0
                                              ? _c("div", [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$vuetify.lang.t(
                                                          "$vuetify.base.deductibleWeight"
                                                        )
                                                      ) +
                                                      ": " +
                                                      _vm._s(
                                                        _vm._f("formatNumber")(
                                                          _vm.getDeductibleWeight(
                                                            img
                                                          )
                                                        )
                                                      ) +
                                                      " " +
                                                      _vm._s(
                                                        _vm.productInfo
                                                          ? _vm.productInfo
                                                              .measureWeight
                                                          : ""
                                                      ) +
                                                      " "
                                                  ),
                                                ])
                                              : _vm._e(),
                                            img.netWeight &&
                                            img.netWeight != img.grossWeight
                                              ? _c("div", [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$vuetify.lang.t(
                                                          "$vuetify.base.netWeight"
                                                        )
                                                      ) +
                                                      ": " +
                                                      _vm._s(
                                                        _vm._f("formatNumber")(
                                                          img.netWeight +
                                                            (img.netAdjustmentWeight
                                                              ? img.netAdjustmentWeight
                                                              : 0)
                                                        )
                                                      ) +
                                                      " " +
                                                      _vm._s(
                                                        _vm.productInfo
                                                          ? _vm.productInfo
                                                              .measureWeight
                                                          : ""
                                                      ) +
                                                      " "
                                                  ),
                                                ])
                                              : _vm._e(),
                                          ]),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "text-caption ma-2",
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm._f("formatDateTime")(
                                                      img.time
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _c(VImg, {
                                        ref: "images",
                                        refInFor: true,
                                        attrs: {
                                          src: img.src,
                                          contain: "",
                                          "aspect-ratio": "1.7",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        }),
                        1
                      )
                    : _c(
                        "div",
                        { staticClass: "text-subtitle-2 font-weight-light" },
                        [_vm._v(" No attachments found ")]
                      ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        VDialog,
        {
          staticStyle: { "z-index": "1000" },
          attrs: { "max-width": "300px;" },
          model: {
            value: _vm.adjustmentDialog,
            callback: function ($$v) {
              _vm.adjustmentDialog = $$v
            },
            expression: "adjustmentDialog",
          },
        },
        [
          _c(
            VCard,
            [
              _c(VCardTitle, { staticClass: "justify-end" }, [
                _c(
                  "div",
                  [
                    _c(
                      VBtn,
                      {
                        attrs: { icon: "" },
                        on: {
                          click: function ($event) {
                            _vm.adjustmentDialog = null
                          },
                        },
                      },
                      [_c(VIcon, [_vm._v("mdi-close")])],
                      1
                    ),
                  ],
                  1
                ),
              ]),
              _c(
                VCardText,
                [
                  _c("worksheet-item-adjustment", {
                    key: _vm.selectedEntry ? _vm.selectedEntry.id : 0,
                    attrs: {
                      worksheetEntry: _vm.selectedEntry,
                      productInfo: _vm.productInfo,
                    },
                    on: {
                      cancel: function ($event) {
                        _vm.adjustmentDialog = null
                      },
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        VDialog,
        {
          staticStyle: { "z-index": "1000" },
          attrs: { "max-width": "720px" },
          model: {
            value: _vm.resolutionDialog,
            callback: function ($$v) {
              _vm.resolutionDialog = $$v
            },
            expression: "resolutionDialog",
          },
        },
        [
          _c(
            VCard,
            [
              _c(
                VCardTitle,
                { staticClass: "justify-space-between" },
                [
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.$vuetify.lang.t(
                          "$vuetify.worksheet.inventoryResolution.title"
                        )
                      )
                    ),
                  ]),
                  _c(
                    VBtn,
                    {
                      attrs: { icon: "" },
                      on: { click: _vm.closeResolutionDialog },
                    },
                    [_c(VIcon, [_vm._v("mdi-close")])],
                    1
                  ),
                ],
                1
              ),
              _c(
                VCardText,
                [
                  _vm.resolutionEntry
                    ? _c("div", { staticClass: "text-subtitle-2 mb-3" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$vuetify.lang.t(
                                "$vuetify.worksheet.inventoryResolution.entryQuantity"
                              )
                            ) +
                            " " +
                            _vm._s(
                              _vm._f("formatNumber")(
                                _vm.resolutionEntry.netWeight
                              )
                            ) +
                            " " +
                            _vm._s(
                              _vm.productInfo
                                ? _vm.productInfo.measureWeight
                                : ""
                            ) +
                            " "
                        ),
                      ])
                    : _vm._e(),
                  _vm.resolutionEntry &&
                  _vm.resolutionEntry.inventoryDecisionNote
                    ? _c("div", { staticClass: "text-body-2 mb-4" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.formatShortageMessage(_vm.resolutionEntry)
                            ) +
                            " "
                        ),
                      ])
                    : _vm._e(),
                  _vm.resolutionLoading
                    ? _c(
                        "div",
                        { staticClass: "py-8 text-center" },
                        [
                          _c(VProgressCircular, {
                            attrs: { indeterminate: "", color: "primary" },
                          }),
                          _c("div", { staticClass: "mt-3" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$vuetify.lang.t(
                                    "$vuetify.worksheet.inventoryResolution.loading"
                                  )
                                ) +
                                " "
                            ),
                          ]),
                        ],
                        1
                      )
                    : _vm.resolutionError
                    ? _c(
                        VAlert,
                        {
                          staticClass: "mb-4",
                          attrs: { type: "error", outlined: "" },
                        },
                        [_vm._v(" " + _vm._s(_vm.resolutionError) + " ")]
                      )
                    : _vm.resolutionOptions.length === 0
                    ? _c(
                        VAlert,
                        {
                          staticClass: "mb-0",
                          attrs: { type: "info", outlined: "" },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$vuetify.lang.t(
                                  _vm.resolutionMode === "location"
                                    ? "$vuetify.worksheet.inventoryResolution.noLocations"
                                    : "$vuetify.worksheet.inventoryResolution.noInventories"
                                )
                              ) +
                              " "
                          ),
                        ]
                      )
                    : _c(
                        VList,
                        { attrs: { "two-line": "" } },
                        _vm._l(_vm.resolutionOptions, function (option) {
                          return _c(
                            VListItem,
                            {
                              key: _vm.resolutionOptionKey(option),
                              staticClass: "px-0",
                            },
                            [
                              _c(
                                VListItemContent,
                                [
                                  _c(VListItemTitle, [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.resolutionOptionTitle(option)
                                        ) +
                                        " "
                                    ),
                                  ]),
                                  _c(VListItemSubtitle, [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.resolutionOptionSubtitle(option)
                                        ) +
                                        " "
                                    ),
                                  ]),
                                ],
                                1
                              ),
                              _c(
                                VListItemAction,
                                [
                                  _c(
                                    VBtn,
                                    {
                                      attrs: {
                                        color: "primary",
                                        loading: _vm.resolutionSubmitting,
                                        disabled: _vm.resolutionSubmitting,
                                      },
                                      on: {
                                        click: function ($event) {
                                          _vm.resolutionMode === "location"
                                            ? _vm.resolveWithLocation(option)
                                            : _vm.resolveWithInventory(option)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$vuetify.lang.t(
                                              "$vuetify.worksheet.inventoryResolution.assign"
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        }),
                        1
                      ),
                ],
                1
              ),
              _c(
                VCardActions,
                { staticClass: "justify-end" },
                [
                  _c(
                    VBtn,
                    {
                      attrs: { text: "" },
                      on: { click: _vm.closeResolutionDialog },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$vuetify.lang.t("$vuetify.base.close")) +
                          " "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("confirmation-dialog", { ref: "confirm" }),
      _c(
        VBottomSheet,
        {
          attrs: { scrollable: "" },
          model: {
            value: _vm.showInventoryDetails,
            callback: function ($$v) {
              _vm.showInventoryDetails = $$v
            },
            expression: "showInventoryDetails",
          },
        },
        [
          _c(
            VCard,
            [
              _c(
                VCardTitle,
                { staticClass: "justify-center" },
                [
                  _c(
                    VBtn,
                    {
                      staticClass: "mt-6",
                      attrs: { text: "" },
                      on: {
                        click: function ($event) {
                          _vm.showInventoryDetails = false
                        },
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$vuetify.lang.t("$vuetify.close")) +
                          " "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                VCardText,
                [
                  _c("inventory-details", {
                    key: _vm.selectedInventory ? _vm.selectedInventory.id : 0,
                    model: {
                      value: _vm.selectedInventory,
                      callback: function ($$v) {
                        _vm.selectedInventory = $$v
                      },
                      expression: "selectedInventory",
                    },
                  }),
                  _vm.selectedInventoryUnit
                    ? _c(
                        "div",
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "text-center text-subtitle-1 my-2 font-weight-light",
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    this.$vuetify.lang.t(
                                      "$vuetify.worksheet.selectedUnit"
                                    )
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                          _c(VSimpleTable, { staticClass: "table" }, [
                            _c("tr", [
                              _c("td", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$vuetify.lang.t(
                                      "$vuetify.inventory.code"
                                    )
                                  )
                                ),
                              ]),
                              _c("td", [
                                _vm._v(_vm._s(_vm.selectedInventoryUnit.code)),
                              ]),
                            ]),
                            _c("tr", [
                              _c("td", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$vuetify.lang.t(
                                        "$vuetify.inventory.numberOfUnits",
                                        _vm.productInfo
                                          ? _vm.productInfo.measureUnit
                                          : "Unit"
                                      )
                                    ) +
                                    " "
                                ),
                              ]),
                              _c("td", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.selectedInventoryUnit.unitShare
                                    ) +
                                    " " +
                                    _vm._s(
                                      _vm.productInfo
                                        ? _vm.productInfo.measureUnit
                                        : ""
                                    ) +
                                    " "
                                ),
                              ]),
                            ]),
                            _c("tr", [
                              _c("td", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$vuetify.lang.t(
                                        "$vuetify.inventory.weightPerUnit",
                                        _vm.productInfo
                                          ? _vm.productInfo.measureUnit
                                          : "Unit"
                                      )
                                    ) +
                                    " "
                                ),
                              ]),
                              _c("td", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm._f("formatNumber")(
                                        _vm.selectedInventoryUnit.amountPerUnit
                                      )
                                    ) +
                                    " " +
                                    _vm._s(
                                      _vm.selectedInventoryUnit.unitMeasure
                                    ) +
                                    " "
                                ),
                              ]),
                            ]),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }